module.exports = __webpack_public_path__ + "static/img/banner1.06be260.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/programme/banner1.png
// module id = Zdha
// module chunks = 1